import React from "react";
 import { ButtonColor } from "./styles";
//o botão recebe duas props:
// function: recebe a função 
// text: o texto para mostrar no botão

function Button(props){
    return(
        <ButtonColor style={props.style} disabled={props.disabled} className={props.className} onClick={props.onClick}>
            {props.icon}
            {props.title}
        </ButtonColor>
    )
}

export default Button;